import { render, staticRenderFns } from "./OpenDialog.vue?vue&type=template&id=4309b630&"
import script from "./OpenDialog.vue?vue&type=script&lang=ts&"
export * from "./OpenDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports